import React from 'react';
import { Toast, ToastContainer as BSToastContainer } from 'react-bootstrap';
import { useToast } from '../hooks/useToast';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  return (
    <BSToastContainer position="top-end" className="p-3" style={{ zIndex: 1050 }}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          show={true}
          onClose={() => removeToast(toast.id)}
          delay={5000}
          autohide
          bg={toast.type}
        >
          <Toast.Body className="text-white">
            {toast.message}
          </Toast.Body>
        </Toast>
      ))}
    </BSToastContainer>
  );
};

export default ToastContainer;